export interface ParentProfile {
  userId: number;
  parentDbId: number;
  parentId: string;
  name: string;
  lastName: string;
  email: string | null;
  phone: string | null;
  phone2: string | null;
  avatar: string | null;
}

export interface Child {
  id: number;
  studentId: string;
  name: string;
  lastName: string;
  avatar: string | null;
  year: string | null;
  status: string;
}

export interface Lesson {
  registerId: number;
  classId: string;
  classDbId: number;
  classType: string | null;
  subject: string;
  subjectColour: string | null;
  subjectCode: string | null;
  subjectImage: string | null;
  year: string | null;
  teacher: string | null;
  /** UTC ISO strings. */
  start: string;
  end: string;
  status: string;
  meetingStatus: string | null;
  cancelled: boolean;
  zoomLink: string | null;
  zoomMeetingId: string | null;
  zoomMeetingPasscode: string | null;
  recordingLink: string | null;
  hasHomework: boolean;
  students: Array<{ id: number; onLeave: boolean; attended: boolean | null }>;
}

export interface TimetableResponse { children: Child[]; lessons: Lesson[]; from: string; to: string; fetchedAt: string }

export type MessageKind = "in" | "out" | "closed" | "reopened";
export interface ChatMessage {
  id: number;
  kind: MessageKind;
  text: string;
  from: "me" | "team";
  agentName: string | null;
  at: string;
  clientId: string | null;
  seen: boolean;
  /** Announcements sent to many parents at once carry a title and the broadcast id. */
  title?: string | null;
  broadcast?: number | null;
  /** Set locally while a message is still being sent. */
  pending?: boolean;
  failed?: boolean;
}
export interface ChatResponse { messages: ChatMessage[]; status: "active" | "closed" | "pending"; readUpTo: number; now: string }

export type ReminderMode = "notification" | "alarm" | "both";
export interface ReminderPrefs {
  enabled: boolean;
  minutesBefore: 0 | 5 | 10 | 15 | 30 | 60;
  mode: ReminderMode;
  sound: boolean;
  vibrate: boolean;
}
export const DEFAULT_REMINDERS: ReminderPrefs = { enabled: true, minutesBefore: 10, mode: "both", sound: true, vibrate: true };

export interface DeviceRecord { id: number; kind: "webpush" | "fcm"; platform: string | null; label: string | null; time_zone: string | null; reminders: ReminderPrefs; last_seen_at: string }
